import PreviewSection from '../../PreviewSection'

export default function StaffPerformanceHTMLPreviewBaseSection () {}

StaffPerformanceHTMLPreviewBaseSection.prototype = new PreviewSection();

StaffPerformanceHTMLPreviewBaseSection.prototype.init = function ( columnsStrategy )
{
    this.columnsStrategy = columnsStrategy;
    return this;
};

StaffPerformanceHTMLPreviewBaseSection.prototype.createRowWithMainAndDataCells = function ( rowClassName, mainCellInnerHtml, mainCellClassName )
{
    let row = this.createRow( rowClassName );
    this.addCell( row, mainCellInnerHtml, mainCellClassName );
    this.columnsStrategy.addDataCells( row );
    return row;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewBaseSection.js